import type { EsaCciScheme } from './esa-cci.types';

/**
 * Dataset-level constants for ESA CCI / C3S Land Cover — single source of truth
 * for the temporal range and scheme list, shared by the tool store, the year
 * `<select>`, and the change panel's from/to pickers. Range mirrors the BE
 * contract (260629_esa_cci_lulc.md): annual 2000–2022, default 2022.
 */
export const ESA_CCI_MIN_YEAR = 2000;
export const ESA_CCI_MAX_YEAR = 2022;
export const ESA_CCI_DEFAULT_YEAR = ESA_CCI_MAX_YEAR;

/** Newest-first so the default sits at the top of the picker. */
export const ESA_CCI_YEARS: number[] = Array.from(
  { length: ESA_CCI_MAX_YEAR - ESA_CCI_MIN_YEAR + 1 },
  (_, i) => ESA_CCI_MAX_YEAR - i,
);

export const ESA_CCI_DEFAULT_SCHEME: EsaCciScheme = 'ipcc';

/**
 * Canonical public "source" for the dataset — the Copernicus Climate Data Store
 * C3S Land Cover entry (DOI 10.24381/cds.006f2c9a). Most authoritative + stable
 * landing page (the sat-io asset we mirror cites this); preferred over secondary
 * aggregators like the CEOS GST page. Linked from the breakdown methodology panel
 * and the ported sidebar card. Licence: CC-BY 4.0.
 */
export const ESA_CCI_SOURCE_URL = 'https://cds.climate.copernicus.eu/datasets/satellite-land-cover';
